import './installation-settings.scss';
import InstallationSettingsTpl from './installation-settings.html';
import InstallationSettingsController from './installation-settings__controller';
import RingSelect from '@jetbrains/ring-ui/components/select-ng/select-ng';
import '@jetbrains/ring-ui/components/input-size/input-size.scss';

export default angular.module('installer.installation-settings', [RingSelect]).
  directive('installationSettings', () => ({
    //restrict: 'E',
    template: InstallationSettingsTpl,
    scope: {},
    bindToController: {
      model: '=',
      defaultModel: '=',
      checkPathAccess: '&',
      getErrorMessage: '&',
      clearErrorMessage: '&',
      getDirectoryHint: '&?',
      advancedToggle: '=?',
      languageSelect: '=?',
      stepUrl: '@',
      showExternalHubUrlFix: '=?',
      onFixExternalHubUrl: '&',
      forceShowListenAddress: '=?',
      disableBaseUrlAutoCorrection: '=?',
      isDisabled: '=?',
      certificateUrl: '=?'
    },
    controllerAs: 'settingsCtrl',
    controller: InstallationSettingsController
  }));



// WEBPACK FOOTER //
// ./src/blocks/installation-settings/installation-settings.js